var layout_default = {
  "layout": "Nw79O",
  "cell": "DBx2-"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
